import { forwardRef } from "react";
import { Item } from "@exiftrator/shared/components/ui";

export interface ListItemProps extends React.ComponentProps<typeof Item> {}

const ListItem = forwardRef<HTMLDivElement, ListItemProps>((props, ref) => {
  return <Item ref={ref} {...props} />;
});

ListItem.displayName = "ListItem";

export { ListItem };
